export default __webpack_public_path__ + "static/media/application-icon-consent.f896ef05.svg";